import { Box, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { MailingItem } from '@app/api/models';
import { TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (id: number) => void;
}): TableColumn<MailingItem>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'key',
      label: 'Ключ',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'description',
      label: 'Описание',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'value',
      label: 'Значение',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string[]) => {
          return (
            <Box whiteSpace="pre-wrap" style={{ 
              wordBreak: 'break-all',
              display: '-webkit-box',
              height: '70px',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
            >
              {value.join(', ')}
            </Box>
          );
        },
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id) => {
          return (
            <>
              <IconButton name="edit" onClick={() => onEdit(id)} aria-label="edit">
                <MdEdit />
              </IconButton>
            </>
          );
        },
      },
    },
  ];
};
